const RTL_RE = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/;
const LTR_RE = /[A-Za-z\u00C0-\u024F]/;

export type SearchTextDirection = {
  direction: "ltr" | "rtl";
  textAlign: "left" | "right";
  writingDirection: "ltr" | "rtl";
};

export function getSearchTextDirection(
  value: string,
  fallbackIsRTL: boolean,
): SearchTextDirection {
  for (const char of value.trim()) {
    if (RTL_RE.test(char)) {
      return {
        direction: "rtl",
        textAlign: "right",
        writingDirection: "rtl",
      };
    }
    if (LTR_RE.test(char)) {
      return {
        direction: "ltr",
        textAlign: "left",
        writingDirection: "ltr",
      };
    }
  }

  return fallbackIsRTL
    ? { direction: "rtl", textAlign: "right", writingDirection: "rtl" }
    : { direction: "ltr", textAlign: "left", writingDirection: "ltr" };
}
